import { Slide } from "@jelly/lesson";
import config from "appConfig";
import { task as task01 } from "../../../../../task/course-03/lesson-06/task-01";

const task: Slide = {
  titleHtml: `A room has a volume of V=400 m³ and a reverberation time of 1.0 s.<br>Down to which frequency can statistical energy models be used?`,
  description: "Select the correct answer.",
  layout: {
    type: "table",
    options: {
      rows: 4,
      cols: 1,
      components: [
        [],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/06/task/task-01-label.svg`,
                  viewType: "auto",
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
        [],
      ],
    },
  },
};

export default task;
